
// Verifica se existe alguma mensagem de sucesso em sessão para exibir ao usuário
// Após a exibição, a mensagem é removida da sessão
document.addEventListener('turbolinks:load', function () {
  const mensagem = sessionStorage.getItem('toast-success');

  if (mensagem) {
    toastr.success(mensagem);
    sessionStorage.removeItem('toast-success');
  }
});